import { render } from "./courseReportInfo.vue?vue&type=template&id=5f2b2320&scoped=true"
import script from "./courseReportInfo.vue?vue&type=script&lang=js"
export * from "./courseReportInfo.vue?vue&type=script&lang=js"

import "./courseReportInfo.vue?vue&type=style&index=0&id=5f2b2320&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2b2320"]])

export default __exports__